import api from './api';

const extractData = (data) => {
  if (data && typeof data === 'object' && data.$values) {
    return data.$values;
  }
  return data;
};

const pagesService = {
  // Retorna todas as páginas do usuário
  async getAll() {
    const response = await api.get('/pages');
    return extractData(response.data);
  },

  // Buscar página por ID
  async getById(id) {
    const response = await api.get(`/pages/${id}`);
    return response.data;
  },

  // Criar nova página (legado — link_in_bio v1, clinic, professional)
  async create(data) {
    const response = await api.post('/pages', data);
    return response.data;
  },

  // Criar nova página site (novos tipos: professional_site, company_site, link_in_bio v2)
  // Espera { type, title, slug, templateId, draftConfig: SiteConfigDto }
  async createSite(data) {
    const response = await api.post('/pages/create-site', data);
    return response.data;
  },

  // Atualizar página (legado — manter por compatibilidade externa)
  async update(id, data) {
    const response = await api.put(`/pages/${id}`, data);
    return response.data;
  },

  // Salvar rascunho de página (novo ciclo draft/published)
  async updateDraft(id, draftConfig) {
    const response = await api.put(`/pages/${id}/draft`, draftConfig);
    return response.data;
  },

  // Publicar página (soft delete com PublishedAt)
  async publish(id) {
    const response = await api.post(`/pages/${id}/publish`);
    return response.data;
  },

  // Despublicar página
  async unpublish(id) {
    const response = await api.post(`/pages/${id}/unpublish`);
    return response.data;
  },

  // Deletar página (soft delete)
  async delete(id) {
    await api.delete(`/pages/${id}`);
  },

  // Obter templates disponíveis para um tipo de página
  async getTemplates(type = 'link-in-bio') {
    const response = await api.get(`/pages/templates/${type}`);
    return response.data;
  },

  // Obter tipos de página disponíveis para seleção no modal
  async getPageTypes() {
    const response = await api.get('/pages/templates/types');
    return response.data;
  },
};

export default pagesService;
